import axios from 'axios';
import {
    FedExEulaStatusResponse,
    FedExEulaAcceptRequest,
    FedExEulaAcceptResponse,
} from '@/models/FedEx/FedExEula';

export class FedExEulaService {
    /**
     * Fetch the current EULA text, version, and the store's acceptance status.
     */
    static async getStatus(storeId: number): Promise<FedExEulaStatusResponse> {
        const response = await axios.get<FedExEulaStatusResponse>(`/api/FedExEula/${storeId}`);
        return response.data;
    }

    /**
     * Record a new EULA acceptance for the store. The caller (admin) is inferred server-side
     * from the authenticated user.
     */
    static async accept(storeId: number, request: FedExEulaAcceptRequest): Promise<FedExEulaAcceptResponse> {
        const response = await axios.post<FedExEulaAcceptResponse>(
            `/api/FedExEula/${storeId}/accept`,
            request,
        );
        return response.data;
    }
}
